import React from 'react';
import { StepperProvider } from '../common/components/StepperContext';
import StepperResource from './StepperResource';

type HireResourceStepperType = {
    resType: string;
    onCancelStepper: () => void;
};

export default (props: HireResourceStepperType) => {
    return (
        <StepperProvider>
            <StepperResource {...props} />
        </StepperProvider>
    );
};
